// For Firebase JS SDK v7.20.0 and later, measurementId is optional

export const firebaseConfig = {
  apiKey: 'AIzaSyAKaTOrAic0Kvvw4prJgsWwOju2-yDDmyw',
  authDomain: 'adastra-connect-app.firebaseapp.com',
  projectId: 'adastra-connect-app',
  storageBucket: 'adastra-connect-app.firebasestorage.app',
  messagingSenderId: '826887906359',
  appId: '1:826887906359:web:e23c66ae71227468bf0bb2',
  measurementId: 'G-T0FGJX09HM',
}
